import type { QuizAttemptPrivate, QuizPrivate, QuizSection } from '@repo/types/quiz';

import { SectionMarked } from '@/components/features/quiz/question/question-marked';

export interface QuizResultContentProps {
  quiz: QuizPrivate;
  attempt: QuizAttemptPrivate;
  selectedIdx: number | null;
}

export default function QuizResultContent(quizResultContentProps: QuizResultContentProps) {
  const { attempt, quiz, selectedIdx } = quizResultContentProps;

  const selectedSection: QuizSection | undefined = selectedIdx != null ? quiz.content.at(selectedIdx) : undefined;
  return (
    <div className="w-full space-y-4">
      {!selectedSection &&
        quiz.content.map((section, idx) => {
          return <SectionMarked key={idx} idx={idx} marked={attempt.body.marked} answers={attempt.body.answers} section={section} />;
        })}
      {selectedSection && selectedIdx != null && (
        <SectionMarked
          key={selectedIdx}
          idx={selectedIdx}
          marked={attempt.body.marked}
          answers={attempt.body.answers}
          //present, see if statement in the top of the component
          section={selectedSection}
        />
      )}
    </div>
  );
}
